var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventFilled = function SvgEventFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M7.5 2.25a.75.75 0 0 1 .75.75v.75h7.5V3a.75.75 0 0 1 1.5 0v.75H18a3.75 3.75 0 0 1 3.75 3.75V18A3.75 3.75 0 0 1 18 21.75H6A3.75 3.75 0 0 1 2.25 18V7.5A3.75 3.75 0 0 1 6 3.75h.75V3a.75.75 0 0 1 .75-.75ZM12 9.458l1.094 2.332 2.448.376-1.771 1.813.418 2.563L12 15.332l-2.189 1.21.418-2.563-1.77-1.813 2.447-.376L12 9.458Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventFilled);
export default ForwardRef;